import React, { FunctionComponent } from 'react'

import { ToastContainer } from 'react-toastify'

import { fontsSettings } from '@/styles'

const NotificationContainer: FunctionComponent = () => (
  <ToastContainer
    theme="colored"
    hideProgressBar
    closeOnClick
    position="top-right"
    style={{ top: '5em' }}
    toastStyle={{
      fontFamily: fontsSettings.textFont,
      fontSize: fontsSettings.fontSize14,
    }}
  />
)

export default NotificationContainer
